module.exports = __webpack_public_path__ + "img/blog-05.9d629bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/posts/blog-05.jpg
// module id = 1167
// module chunks = 1